import axiosInstance from "../../config/Axios";

export const getProducts = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/duka/products/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createProduct = async (productData) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/duka/products/',
            data: productData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateProduct = async (id, productData) => {
    try {
        return await axiosInstance({
            method: 'put',
            url: `/api/duka/products/${id}/`,
            data: productData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteProduct = async (id) => {
    if (!id) {
        return Promise.reject(new Error('Product ID is required'));
    }
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/duka/products/${id}/`,
        });
        return response;
    } catch (error) {
        console.error('Delete API Error:', error?.response?.data || error.message);
        return Promise.reject(error);
    }
};

export const getProductById = async (id) => {
    try {
        return await axiosInstance({
            method: 'get',
            url: `/api/duka/products/${id}/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

// Product Group API
export const getProductGroup = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/duka/product-groups/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getProductGroupById = async (id) => {
    try {
        return await axiosInstance({
            method: 'get',
            url: `/api/duka/product-groups/${id}/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createProductGroup = async (productGroupData) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/duka/product-groups/',
            data: productGroupData,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateProductGroup = async (id, productGroupData) => {
    try {
        return await axiosInstance({
            method: 'put',
            url: `/api/duka/product-groups/${id}/`,
            data: productGroupData,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteProductGroup = async (id) => {
    if (!id) {
        return Promise.reject(new Error("Product Group ID is required"));
    }
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/duka/product-groups/${id}/`,
        });
        return response;
    } catch (error) {
        console.error("Delete API Error:", error?.response?.data || error.message);
        return Promise.reject(error);
    }
};

export const bulkUploadProduct = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      return await axiosInstance({
        method: "post",
        url: "/api/duka/product/bulk-upload/",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
  
export const getCategories = async () => {
try {
    const response = await axiosInstance({
    method: "get",
    url: "/api/duka/product-categories/",
    });
    return response.data;
} catch (error) {
    return Promise.reject(error);
}
};

export const getSubCategories = async () => {
try {
    const response = await axiosInstance({
    method: "get",
    url: "/api/duka/product-sub-categories/",
    });
    return response.data;
} catch (error) {
    return Promise.reject(error);
}
};

export default {
    getProducts,
    createProduct,
    updateProduct,
    deleteProduct,
    getProductById,
    getProductGroup,
    getProductGroupById,
    createProductGroup,
    updateProductGroup,
    deleteProductGroup,
    bulkUploadProduct,
    getCategories,
    getSubCategories
};